import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcButtonIcon } from '@pc/common';
import { IconComponent } from '@pc/icon';
import { StepData } from '../models/step-data.interface';
import { StepState } from '../models/step-state.enum';
import { LanguageCode, TranslationService } from '@pc/translation';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pc-step-view',
  standalone: true,
  imports: [CommonModule, IconComponent, TranslateModule],
  templateUrl: './step-view.component.html',
  styleUrl: './step-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepViewComponent implements OnChanges {
  @Input({ required: true }) step!: StepData;
  @Input() isLastStep = false;
  public PcButtonIcon = PcButtonIcon;
  public StepState = StepState;
  public icon = PcButtonIcon.CIRCLE_CHECKBOX_UNSELECTED;
  public isFlipArrowIcon = false;
  private translationService = inject(TranslationService);

  ngOnChanges(changes: SimpleChanges) {
    if (this.translationService.getCurrentLang() !== LanguageCode.HE_IL) {
      this.isFlipArrowIcon = true;
    }
    if (changes['step']) {
      this.icon =
        this.step.state === StepState.COMPLETED
          ? PcButtonIcon.CIRCLE_CHECKBOX_SELECTED
          : this.step.state === StepState.CURRENT
            ? PcButtonIcon.CIRCLE_RIGHT
            : PcButtonIcon.CIRCLE_CHECKBOX_UNSELECTED;
    }
  }
}
